import Vue from 'vue';
import { backgroundJobsService } from "../services/backgroundJobs.service";

const state = {}
const getters = {}

const actions = {
    async fetchReportingJobs({ commit }) {
        try {
            const reportingJobs = await backgroundJobsService.fetchReportingJobs();
            return reportingJobs;
        } catch (error) {
            return Promise.reject(error)
        }
    }
}

const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};